/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClientApplication {
    TeamTraining = 0,
    Archive = 1,
    CamView = 2,
    RoomCast = 3,
    HealthMonitor = 4,
    Bookmarks = 5,
    Checklists = 6,
    AudioToRoom = 7,
    ScenarioMedias = 8,
    ScenarioDesigner = 9,
    EventPlanner = 10,
    Debriefing = 11,
    Presentation = 12,
    UserManagement = 13,
    StageDesigner = 14,
    RoomPlanner = 15,
    MediaManagement = 16,
    SyncRecordings = 17,
    AudioOfPatient = 18,
    Assessments = 19,
    AssessmentsConducted = 20,
    DeviceRegistration = 21,
    ExamArchive = 22,
    ExamFlow = 23,
    RemoteExamination = 24,
    PeerPracticeStudentApp = 25,
    ExamDeviceMode = 26,
}
